"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asEnumValueOrFail = exports.InvalidEnumValueError = void 0;
class InvalidEnumValueError extends Error {
    constructor(value, expectedValues) {
        super(`invalid enum value: ${value} is not a member of ${expectedValues.join(', ')}`);
        this.value = value;
        this.expectedValues = expectedValues;
    }
}
exports.InvalidEnumValueError = InvalidEnumValueError;
const asEnumValueOrFail = (type, str) => {
    if (!Object.values(type).includes(str)) {
        throw new InvalidEnumValueError(str, Object.values(type));
    }
    return str;
};
exports.asEnumValueOrFail = asEnumValueOrFail;
//# sourceMappingURL=enum.js.map